import React from 'react';
import { Edit3, BarChart, HeartPulse, Users, ShieldCheck, AlertTriangle, Flag } from 'lucide-react';
import { CTAButton } from './CTAButton';
const tomos = [{
  number: 1,
  title: 'Salud y Enfermedad',
  subtitle: 'Del concepto a la realidad',
  icon: <HeartPulse className="w-5 h-5" data-id="element-195" />,
  color: 'from-cyan-600/20 to-teal-600/20',
  borderColor: 'border-cyan-500/30',
  iconBg: 'bg-cyan-500/20',
  iconColor: 'text-cyan-400',
  topics: ['Concepto OMS', 'Determinantes sociales', 'Sistema argentino', 'Salud colectiva', 'Barreras de acceso'],
  activities: 10,
  projects: 2
}, {
  number: 2,
  title: 'Adolescencia como Construcción Social',
  subtitle: 'Identidad y cambios',
  icon: <Users className="w-5 h-5" data-id="element-196" />,
  color: 'from-blue-600/20 to-indigo-600/20',
  borderColor: 'border-blue-500/30',
  iconBg: 'bg-blue-500/20',
  iconColor: 'text-blue-400',
  topics: ['Cambios físicos', 'Identidad', 'Cultura', 'Presión de grupo', 'Diversidad'],
  activities: 10,
  projects: 2
}, {
  number: 3,
  title: 'Salud Sexual y Reproductiva',
  subtitle: 'ESI, derechos y decisiones',
  icon: <ShieldCheck className="w-5 h-5" data-id="element-197" />,
  color: 'from-emerald-600/20 to-green-600/20',
  borderColor: 'border-emerald-500/30',
  iconBg: 'bg-emerald-500/20',
  iconColor: 'text-emerald-400',
  topics: ['Marco ESI', 'Anticonceptivos', 'ITS', 'Embarazo adolescente', 'Diversidad sexual'],
  activities: 10,
  projects: 2
}, {
  number: 4,
  title: 'Consumos Problemáticos',
  subtitle: 'Alcohol, drogas y pantallas',
  icon: <AlertTriangle className="w-5 h-5" data-id="element-198" />,
  color: 'from-amber-600/20 to-orange-600/20',
  borderColor: 'border-amber-500/30',
  iconBg: 'bg-amber-500/20',
  iconColor: 'text-amber-400',
  topics: ['Alcohol y tabaco', 'Drogas', 'Adicciones digitales', 'Factores de riesgo', 'Prevención'],
  activities: 10,
  projects: 2
}, {
  number: 5,
  title: 'Salud y Ciudadanía',
  subtitle: 'Del aula a la acción',
  icon: <Flag className="w-5 h-5" data-id="element-199" />,
  color: 'from-violet-600/20 to-purple-600/20',
  borderColor: 'border-violet-500/30',
  iconBg: 'bg-violet-500/20',
  iconColor: 'text-violet-400',
  topics: ['Salud como derecho', 'Políticas públicas', 'Hábitos saludables', 'Participación juvenil'],
  activities: 8,
  projects: 3
}];
export function Tomos() {
  return <section className="py-16 bg-brand-dark px-4" data-id="element-200">
      <div className="max-w-5xl mx-auto" data-id="element-201">
        <div className="text-center mb-12" data-id="element-202">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-white mb-3 uppercase" data-id="element-203">
            ¿Qué incluye el Sistema?
          </h2>
          <p className="text-lg text-gray-400 font-body max-w-2xl mx-auto" data-id="element-204">
            5 TOMOS diseñados para cubrir cada aspecto de tu año escolar
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-205">
          {tomos.map(tomo => <div key={tomo.number} className={`bg-gradient-to-br ${tomo.color} rounded-xl border ${tomo.borderColor} p-5 hover:scale-[1.02] transition-transform duration-200`} data-id="element-206">
              <div className="flex items-center gap-3 mb-3" data-id="element-207">
                <div className={`${tomo.iconBg} p-2 rounded-lg ${tomo.iconColor}`} data-id="element-208">
                  {tomo.icon}
                </div>
                <div data-id="element-209">
                  <span className="text-brand-accent text-xs font-heading font-bold uppercase" data-id="element-210">
                    Tomo {tomo.number}
                  </span>
                  <h3 className="text-white font-heading font-bold text-sm leading-tight uppercase" data-id="element-211">
                    {tomo.title}
                  </h3>
                </div>
              </div>

              <p className="text-xs text-brand-accent italic font-bold mb-3" data-id="element-212">
                {tomo.subtitle}
              </p>

              <div className="flex flex-wrap gap-1.5 mb-4" data-id="element-213">
                {tomo.topics.map((topic, idx) => <span key={idx} className="text-[10px] bg-white/10 text-gray-300 px-2 py-0.5 rounded-full border border-white/5 font-body" data-id="element-214">
                    {topic}
                  </span>)}
              </div>

              <div className="flex items-center gap-3 text-xs text-gray-400 pt-3 border-t border-white/10 font-body" data-id="element-215">
                <div className="flex items-center gap-1" data-id="element-216">
                  <Edit3 className="w-3 h-3 text-brand-accent" data-id="element-217" />
                  <span data-id="element-218">{tomo.activities} actividades</span>
                </div>
                <div className="flex items-center gap-1" data-id="element-219">
                  <BarChart className="w-3 h-3 text-brand-accent" data-id="element-220" />
                  <span data-id="element-221">{tomo.projects} proyectos</span>
                </div>
              </div>
            </div>)}
        </div>

        <div className="mt-12 text-center" data-id="element-222">
          <CTAButton text="👉 Quiero los 5 Tomos ahora" data-id="element-223" />
        </div>
      </div>
    </section>;
}